import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import VideoCard from '@/components/base/VideoCard';
import { categories } from '@/mocks/categories';
import { videos } from '@/mocks/videos';

const categorySchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '分类浏览',
  description: '福利视频在线分类浏览页面，按类别查找海量视频资源',
  url: 'https://fulishipin.com/category',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const categoryVideos = videos.filter((v) => v.category === currentCategory.slug);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(categorySchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/60">
            <div className="container-custom">
              <Breadcrumb items={breadcrumbItems} />
              <div className="pb-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className={`${currentCategory.icon} text-lg`}></i>
                  </div>
                  <h1 className="text-2xl md:text-3xl font-heading text-foreground-950">
                    {currentCategory.name}
                  </h1>
                </div>
                <p className="text-sm text-foreground-500 ml-[52px]">
                  {currentCategory.description}
                </p>
              </div>
            </div>
          </div>

          <div className="container-custom py-4">
            <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                    cat.slug === currentCategory.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/60'
                  }`}
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-xs`}></i>
                  </div>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="container-custom pb-16">
            {categoryVideos.length > 0 ? (
              <>
                <div className="flex items-center justify-between mb-6">
                  <p className="text-sm text-foreground-500">
                    共找到 <strong className="text-foreground-800">{categoryVideos.length}</strong> 个视频
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {categoryVideos.map((video) => (
                    <VideoCard key={video.id} video={video} />
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                  <i className="ri-video-line text-3xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无视频，请浏览其他分类</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}